export default __webpack_public_path__ + "static/media/03c_fold-15.bee2a0dc.mp4";